<template>
  <!--<div class="flex items-center space-x-1">
    <button 
      class="toolbar-btn" 
      @click="$emit('add-line-above')" 
      title="Add blank line above"
    >
      <img src='/images/icons/tiptap/newlinetop.svg' style="width:25px;" />
    </button>
    <button 
      class="toolbar-btn" 
      @click="$emit('add-line-below')" 
      title="Add blank line below"
    >
      <img src='/images/icons/tiptap/newlinebottom.svg' style="width:25px;" />
    </button>
  </div>-->
</template>

<script>
export default {
  name: 'LineManagementButtons',
  props: {
    editor: {
      type: Object,
      required: true
    }
  }
}
</script> 
